import { ThirdPartyScript } from "./thirdPartyScript";
import {
  scriptTagAttributeForCookieConsentManagement,
  classNameForCookieConsentManagement,
  ONETRUST_CONSENT_MANAGEMENT,
} from "helpers/onetrust-helper";
import { useFeatureFlags } from "../FeatureFlagsContext";
import { useEffect } from "react";
import { getEnvironmentName } from "helpers/environment-helpers";

export const ConvergeInit = () => {
  useEffect(() => {
    const loadConvergeScript = async () => {
      if (getEnvironmentName() === "production") {
        await import("vendor/converge/converge-production-WYLQOo.js");
      } else {
        await import("vendor/converge/converge-testing-fr6b6W");
      }
    };

    loadConvergeScript();
  }, []);
};

export const ConvergePixel = () => {
  // Fetch feature flags
  const flags = useFeatureFlags();
  return (
    <>
      <ThirdPartyScript
        id="converge-script"
        class={classNameForCookieConsentManagement([ONETRUST_CONSENT_MANAGEMENT["COOKIE_CATEGORIES"]["TARGETING"]])}
        type={scriptTagAttributeForCookieConsentManagement(flags)}
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.cvg||(c=window.cvg=function(){c.process?c.process.apply(c,arguments):c.queue.push(arguments)},c.queue=[]);
            cvg({method: "consent", consent: true});
            `,
        }}
      />
      <ConvergeInit />
    </>
  );
};
